import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TalentAgencyReconnectAnalyticsSocialAuthRedirectUrl.graphql';
import { Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs } from '../../__generated__/globalTypes';

export const useTalentAgencyReconnectAnalyticsSocialAuthRedirectUrlQuery = (
  options?: QueryHookOptions<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTalentAgencyReconnectAnalyticsSocialAuthRedirectUrlLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>
): QueryResult<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs> & {
  getTalentAgencyReconnectAnalyticsSocialAuthRedirectUrl: LazyQueryExecFunction<
    Query,
    QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTalentAgencyReconnectAnalyticsSocialAuthRedirectUrl, result] = useLazyQuery<
    Query,
    QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTalentAgencyReconnectAnalyticsSocialAuthRedirectUrl, ...result };
};

export const useTalentAgencyReconnectAnalyticsSocialAuthRedirectUrlPromiseQuery = () => {
  const client = useApolloClient();

  const getTalentAgencyReconnectAnalyticsSocialAuthRedirectUrl = useCallback(
    (options?: Omit<QueryOptions<QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs, Query>, 'query'>) =>
      client.query<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTalentAgencyReconnectAnalyticsSocialAuthRedirectUrl };
};
// Suspense Query Hooks
export const useTalentAgencyReconnectAnalyticsSocialAuthRedirectUrlSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytalentAgencyReconnectAnalyticsSocialAuthRedirectUrlArgs>(QUERY, {
    ...options
  });

  return result;
};
